import { createGlobalStyle } from 'styled-components';
import { fromTheme } from 'lib_ui-primitives';

import 'react-tooltip/dist/react-tooltip.css';
import './fonts.css';

// Global styles go here
// Font declarations have been moved to fonts.css
export default createGlobalStyle`

    .highcharts-color-0 {
        fill: ${({ theme }) => theme.chartColors[0]};
        stroke: ${({ theme }) => theme.chartColors[0]};
    }
    .highcharts-color-1 {
        fill: ${({ theme }) => theme.chartColors[1]};
        stroke: ${({ theme }) => theme.chartColors[1]};
    }

    .highcharts-color-2 {
        fill: ${({ theme }) => theme.chartColors[2]};
        stroke: ${({ theme }) => theme.chartColors[2]};
    }

    .highcharts-color-3 {
        fill: ${({ theme }) => theme.chartColors[3]};
        stroke: ${({ theme }) => theme.chartColors[3]};
    }

    .highcharts-color-4 {
        fill: ${({ theme }) => theme.chartColors[4]};
        stroke: ${({ theme }) => theme.chartColors[4]};
    }

    .highcharts-color-5 {
        fill: ${({ theme }) => theme.chartColors[5]};
        stroke: ${({ theme }) => theme.chartColors[5]};
    }

    .highcharts-color-6 {
        fill: ${({ theme }) => theme.chartColors[6]};
        stroke: ${({ theme }) => theme.chartColors[6]};
    }

    .highcharts-color-7 {
        fill: ${({ theme }) => theme.chartColors[7]};
        stroke: ${({ theme }) => theme.chartColors[7]};
    }

    .highcharts-color-8 {
        fill: ${({ theme }) => theme.chartColors[8]};
        stroke: ${({ theme }) => theme.chartColors[8]};
    }

    .highcharts-color-9 {
        fill: ${({ theme }) => theme.chartColors[9]};
        stroke: ${({ theme }) => theme.chartColors[9]};
        color: hsl(200, 100%, 50%);
    }

    .highcharts-background {
        fill: none;
    }

    ${({ theme }) =>
        theme.selectedTheme === 'gl2025'
            ? `
        .highcharts-halo {
            display: none;
        }
        .highcharts-grid-line, .highcharts-axis-line {
            stroke: none;
        }
        .highcharts-header, .highcharts-tooltip {
            color: ${theme.charts.tooltip.titleColor};
            fill: ${theme.charts.tooltip.bodyColor};
        }
        .highcharts-header {
            font-size: ${theme.charts.tooltip.titleFont.fontSize}px !important;
            font-weight: ${theme.charts.tooltip.titleFont.fontWeight} !important;
        }
        .highcharts-tooltip {
            font-size: ${theme.charts.legend.labelFont.fontSize}px;
            font-weight: normal;
        }
        .highcharts-tooltip-box {
            fill: ${theme.charts.tooltip.backgroundColor} !important;
            fill-opacity: 1;
            border-radius: ${theme.charts.tooltip.borderRadius}px;
            border: ${theme.charts.tooltip.borderWidth}px solid ${theme.charts.tooltip.borderColor};
        }
        .highcharts-tooltip > text {
            fill: ${theme.charts.tooltip.bodyColor} !important;
            font-size: ${theme.charts.tooltip.bodyFont.fontSize}px !important;
        }
        g.highcharts-series, .highcharts-point, .highcharts-markers, .highcharts-data-labels {
            transition: none;
        }
        .highcharts-series .highcharts-point,
        .highcharts-series path {
            stroke: none !important;
        }
        .highcharts-pie-series .highcharts-point:hover,
        .highcharts-pie-series .highcharts-point-hover,
        .highcharts-series-pie .highcharts-point:hover,
        .highcharts-series-pie .highcharts-point-hover {
            stroke: ${theme.charts.pie.activeSliceColor} !important;
            stroke-width: ${theme.charts.pie.activeBorderSize}px !important;
        }
    `
            : `
        .highcharts-grid-line {
            stroke-width: 0 !important;
        }
        .highcharts-pie-series .highcharts-point {
            stroke-linejoin: round;
            stroke: #ffffff;
        }
        .highcharts-column-series path.highcharts-point, .highcharts-bar-series path.highcharts-point {
            stroke: #ffffff;
        }
        .highcharts-legend-item-hidden * {
            fill: ${theme.backgroundColorDarker} !important;
            stroke: ${theme.backgroundColorDarker} !important;
        }
        .highcharts-legend-item > text {
            fill: ${theme.defaultFontColor};
        }
        .highcharts-legend-item:hover text {
            fill: ${theme.charts.legendHoverColor};
            font-size: 1em;
        }
    `};

    .highcharts-axis-labels {
        fill: ${fromTheme('defaultFontColor')} !important;
        font-size: 1em !important;
    }

    .highcharts-container, .highcharts-legend-box {
        font-family: ${fromTheme('font')};
        font-size: ${fromTheme('fontSize')};
    }

    .highcharts-legend-nav-active {
        fill: ${fromTheme('charts', 'legendNavActive')};
    }

    .blocklySvg {
        background-color: ${({ theme }) => (theme.darkMode ? '#333' : '#fff')} !important;
    }

    .introjs-tooltip {
        background-color: ${({ theme }) => theme.baseBackgroundColor};
        border-radius: ${({ theme }) => theme.borderRadius}px;
        box-shadow: ${({ theme }) =>
            theme.darkMode
                ? '8px 11px 13px -2px #000000f0, 4px 23px 39px 0px #5787a9c0'
                : '4px 4px 11px -2px #000000d0, 4px 16px 32px 4px #5787a970'};
    }
    .introjs-tooltiptext {
        background-color: ${({ theme }) => theme.backgroundHint};
        font-family: ${({ theme }) => theme.font};
        color: ${({ theme }) => theme.defaultFontColor};
    }
    .introjs-tooltiptext > p {
        font-family: ${({ theme }) => theme.font};
        text-shadow: none;
        margin-block-end: 20px;
        margin-block-start: 4px;
    }
    .introjs-button {
        background-color: ${({ theme }) => theme.button.primary};
        color: ${({ theme }) => theme.button.fontColor};
        border-radius: ${({ theme }) => theme.button.borderRadius}px;
        font-size: ${({ theme }) => theme.button.fontSize}px;
        text-transform: uppercase;
        border: 3px solid transparent;
        font-family: ${({ theme }) => theme.font};
        text-shadow: none;
    }
    .introjs-button:hover {
        background-color: ${({ theme }) => theme.button.primaryHover};
        color: ${({ theme }) => theme.button.fontColor};
    }
    .introjs-button:active {
        background-color: ${({ theme }) => theme.button.primaryHighlight};
        color: ${({ theme }) => theme.button.fontColor};
    }
    .introjs-button:focus {
        background-color: ${({ theme }) => theme.button.primaryHover};
        color: ${({ theme }) => theme.button.fontColor};
    }
    .introjs-arrow.bottom {
        border-top-color: ${({ theme }) => (theme.darkMode ? '#444' : '#ccc')};
        bottom: -16px;
        left: 8px;
    }
    .introjs-arrow.top-right {
        top: -16px;
        right: 8px;
        border-bottom-color: ${({ theme }) => (theme.darkMode ? '#444' : '#ccc')};
    }
    .introjs-arrow {
        border: 8px solid transparent;
    }
    .introjs-arrow.top-middle {
        top: -16px;
        left: 50%;
        margin-left: -5px;
        border-bottom-color: ${({ theme }) => (theme.darkMode ? '#444' : '#ccc')};
    }
    .introjs-arrow.bottom-middle {
        bottom: -16px;
        left: 50%;
        margin-left: -5px;
        border-top-color: ${({ theme }) => (theme.darkMode ? '#444' : '#ccc')};
    }
    .introjs-arrow.bottom-right {
        bottom: -16px;
        right: 8px;
        border-top-color: ${({ theme }) => (theme.darkMode ? '#444' : '#ccc')};
    }
    .introjs-arrow.top {
        top: -16px;
        left: 8px;
        border-bottom-color: ${({ theme }) => (theme.darkMode ? '#444' : '#ccc')};
    }
    .introjs-hint {
        padding-left:6px;
    }

    .szh-menu {
        background-color: ${fromTheme('menu', 'backgroundColor')};
        padding: ${fromTheme('viewPadding')};
        margin-left: ${fromTheme('textMargin')};
        border-radius: ${fromTheme('menu', 'borderRadius')};
        border-style: solid;
        border-width: 1px;
        border-color: ${fromTheme('menu', 'borderColor')};
        font-family: ${fromTheme('font')};
        max-width: ${fromTheme('width')};
    }
    .szh-menu > * {
        border-radius: ${fromTheme('menu', 'menuItem', 'borderRadius')};
    }
    .szh-menu__item {
        color: ${fromTheme('defaultFontColor')};
        padding: ${fromTheme('menu', 'menuItem', 'padding')};
    }

    .szh-menu__item--hover {
        background-color: ${fromTheme('menu', 'menuItem', 'hoverBackgroundColor')};
        border-radius: ${fromTheme('menu', 'menuItem', 'borderRadius')};
    }
    .szh-menu__item--hover.szh-menu__item--focusable {
        background-color: inherit;
    }
   
    .szh-menu__submenu > .szh-menu__item::after {
        font-size: ${fromTheme('menu', 'subMenu', 'chevronSize')};
        right: ${fromTheme('menu', 'subMenu', 'chevronRightOffset')};
    }

    .notifications-menu.szh-menu {
        gap: 0;
        max-width: ${fromTheme('notifications', 'maxWidth')};
        min-width: ${fromTheme('notifications', 'minWidth')};
    }
    .notifications-menu.szh-menu > *:last-child {
        border-radius: ${fromTheme('menu', 'borderRadius')};
    }
    .notifications-menu.szh-menu, .notifications-menu .szh-menu__item {
        padding: 0;
    }
    .notifications-menu p[name="h1"] {
        margin: 0;
    }
    .notification-header-button {
        cursor: pointer;
        margin-left: ${fromTheme('notifications', 'header', 'button', 'marginLeft')};
    }
    .action-button:focus {
        box-shadow: none !important;
    }
    .action-menu {
        padding: ${fromTheme('menu', 'actionMenu', 'padding')} !important;
        color: ${fromTheme('menu', 'color')};
        ${fromTheme('menu', 'actionMenu', 'menuItem', 'defaultFont')}
    }
    .action-menu li[name="menu-divider"] {
        margin-bottom: ${fromTheme('menu', 'actionMenu', 'divider', 'marginBottom')};
    }
    div[name="Menu"][role="listbox"] {
        z-index: ${({ theme }) => theme.zindex.DropDownList};
    }

    .saturation-black {
        background: -webkit-linear-gradient(to top, #000, rgba(6, 5, 5, 0));
        background: linear-gradient(to top, #000, rgba(0,0,0,0));
    }
    .saturation-white {
        background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));
        background: linear-gradient(to right, #fff, rgba(255,255,255,0));
    }

    .hue-horizontal {
        background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0
        33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
        background: -webkit-linear-gradient(to right, #f00 0%, #ff0
        17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
    }

    .hue-vertical {
        background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,
        #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
        background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,
        #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
    }
`;
